import React from 'react'
import {
  Select,
  SelectContent,
  SelectTrigger,
  SelectValue,
  SelectItem,
} from '@/components/ui/select'
import { cn } from '@/lib/utils'
import {
  UserFieldTypeOptions,
  TicketFieldTypeOptions,
} from '@/constants/setting'

const SelectFieldType = React.forwardRef(
  ({ onChange, type = 'user', ...props }, ref) => {
    return (
      <Select {...props} onValueChange={(value) => onChange(value)}>
        <SelectTrigger
          ref={ref}
          className={cn(!props.value && 'text-muted-foreground')}
        >
          <SelectValue placeholder="Chọn kiểu dữ liệu" />
        </SelectTrigger>
        <SelectContent>
          {(type == 'ticket'
            ? TicketFieldTypeOptions
            : UserFieldTypeOptions
          ).map((option) => (
            <SelectItem key={option.value} value={option.value}>
              {option.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    )
  },
)

SelectFieldType.displayName = 'SelectFieldType'

export default SelectFieldType
